import { LibraryObject } from '@ansys/cloud-angular-client';
import {
  AWCTableCell,
  TableCellAlign,
  TableCellTypes,
} from '@ansys-internal/awc-angular/tables';
import { TableColumn } from '@ansys-internal/awf-angular/contributions';
import { AWFTable, AWFTableColumn } from '@ansys-internal/awf-angular/core';
import { FilesTable } from '@ansys-internal/awf-angular/dashboard';
import { ContributionsEnum } from '../../contributions.enum';

@AWFTableColumn({
  id: ContributionsEnum.FILES_TABLE_LOGO_COLUMN,
  priority: 0,
})
export class FilesLogoColumn implements TableColumn {
  public id: string = ContributionsEnum.FILES_TABLE_LOGO_COLUMN;
  public priority: number = 0;
  public header: string = '';
  public type: TableCellTypes = TableCellTypes.ICON;
  public align: TableCellAlign = TableCellAlign.CENTER;
  public width: number = 50;

  public render(data: LibraryObject): Promise<AWCTableCell> {
    return Promise.resolve({
      value: 'assets/icons/concept_ev.svg',
      externalSrc: true,
    });
  }
}
